/* eslint-disable no-param-reassign */
import { collectEdgePoints } from '../../preprocess/collect-edge-points';
import { findSccs } from '../../preprocess/find-sccs';
import { trackPaths } from '../../preprocess/track-paths';
import { DirectedCycles } from '../../type/common.interface';
import { Cache } from '../../utils/cache';

const detectCharCache = new Cache<{
    charDirectedCycles: DirectedCycles;
}>(1000);

function generateDetectCharCacheKey(char: string, font: string): string {
    return `${char},${font}`;
}

export function detectChar(char: string, font: string, width: number, height: number) {
    if (!width || !height) return {
        charDirectedCycles: [
            [
                { x: 0, y: 0 },
                { x: 0, y: height },
            ],
            [
                { x: 0, y: 0 },
                { x: width, y: 0 },
            ],
        ] as DirectedCycles,
    };

    const cacheKey = generateDetectCharCacheKey(char, font);
    const cachedResult = detectCharCache.get(cacheKey);

    if (cachedResult) return cachedResult;

    const adjustWidth = 100;
    const adjustHeight = 100;
    const offsetX = Math.ceil(adjustWidth / 2);
    const offsetY = Math.ceil(adjustHeight / 2);

    // 确保可以完整渲染文本
    const canvasWidth = width + adjustWidth;
    const canvasHeight = height + adjustWidth;

    // 创建真正的离屏 canvas，其尺寸正好容纳文本
    const canvas = new OffscreenCanvas(canvasWidth, canvasHeight);
    const ctx = canvas.getContext('2d') as OffscreenCanvasRenderingContext2D;

    // 探测字符前置操作
    ctx.font = font;
    ctx.fillStyle = 'rgb(255, 0, 0)';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(char, canvasWidth / 2, canvasHeight / 2);

    // 开始收集边缘点
    const charEdgePoints = collectEdgePoints(ctx);

    // 寻找字符边缘点有向环
    const charDirectedCycles = findSccs(charEdgePoints)
        .map(scc => trackPaths(scc))
        .flat();

    // 去除偏移,
    charDirectedCycles.forEach((cycle) => {
        cycle.forEach((point) => {
            point.x -= offsetX;
            point.y -= offsetY;
        });
    });

    // 缓存有向环
    detectCharCache.set(cacheKey, { charDirectedCycles });

    return { charDirectedCycles };
}
